export default {
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    reset: 'Reset',
    save: 'Save',
    logout: 'Logout',
    success: 'Success',
    error: 'Error',
    noData: 'No data',
    confirmDelete: 'Are you sure to delete this record?',
    pleaseInput: 'Please input',
    pleaseSelect: 'Please select',
    all: 'All',
    detail: 'Detail',
    operation: 'Operation',
    id: 'ID',
    changePassword: 'Change Password',
    back: 'Back'
  },
  menu: {
    area: 'Area Management',
    user: 'User Management',
    device: 'Device Management',
    version: 'Version Management',
    versionFirmware: 'Firmware',
    versionApp: 'App Version'
  },
  login: {
    title: 'Login',
    loginName: 'Login Name',
    password: 'Password',
    loginBtn: 'Login',
    loginNamePlaceholder: 'Please enter login name',
    passwordPlaceholder: 'Please enter password',
    loginSuccess: 'Login successful',
    loginFail: 'Login failed',
    pleaseInputLoginName: 'Please enter login name',
    pleaseInputPassword: 'Please enter password'
  },
  area: {
    title: 'Area Management',
    addArea: 'Add Area',
    editArea: 'Edit Area',
    areaName: 'Area Name',
    areaDetail: 'Area Description',
    parentArea: 'Parent Area',
    level: 'Level',
    createTime: 'Create Time',
    areaNamePlaceholder: 'Please enter area name',
    areaDetailPlaceholder: 'Please enter area description',
    topArea: 'Top Level Area',
    operation: 'Operation',
    pleaseInputAreaName: 'Please enter area name',
    deleteAreaConfirm: 'Are you sure to delete this area?',
    deleteSuccess: 'Delete successful',
    deleteFail: 'Delete failed',
    updateSuccess: 'Update successful',
    updateFail: 'Update failed',
    addSuccess: 'Add successful',
    addFail: 'Add failed',
    submitFail: 'Submit failed',
    getAreaListFail: 'Failed to get area list'
  },
  user: {
    title: 'User Management',
    addUser: 'Add User',
    editUser: 'Edit User',
    userName: 'User Name',
    loginName: 'Login Name',
    phone: 'Phone',
    role: 'Role',
    area: 'Area',
    status: 'Status',
    createTime: 'Create Time',
    userNamePlaceholder: 'Please enter user name',
    loginNamePlaceholder: 'Please enter login name',
    phonePlaceholder: 'Please enter phone number',
    valid: 'Active',
    invalid: 'Inactive',
    allStatus: 'All Status',
    allRoles: 'All Roles',
    keyword: 'Keyword',
    areaName: 'Area',
    pleaseInputUserName: 'Please enter user name',
    pleaseInputLoginName: 'Please enter login name',
    pleaseInputPhone: 'Please enter phone number',
    pleaseSelectRole: 'Please select role',
    pleaseSelectArea: 'Please select area',
    deleteUserConfirm: 'Are you sure to delete this user?',
    deleteSuccess: 'Delete successful',
    deleteFail: 'Delete failed',
    updateSuccess: 'Update successful',
    updateFail: 'Update failed',
    addSuccess: 'Add successful',
    addFail: 'Add failed',
    submitFail: 'Submit failed',
    getUserListFail: 'Failed to get user list',
    getRoleListFail: 'Failed to get role list',
    getAreaListFail: 'Failed to get area list'
  },
  device: {
    title: 'Device Management',
    addDevice: 'Add Device',
    editDevice: 'Edit Device',
    deviceDetail: 'Device Detail',
    deviceId: 'Device ID',
    deviceName: 'Device Name',
    deviceType: 'Device Type',
    batchId: 'Batch ID',
    deviceNumber: 'Controller Number',
    area: 'Area',
    status: 'Status',
    createTime: 'Create Time',
    deviceNamePlaceholder: 'Please enter device name',
    keywordPlaceholder: 'Please enter keyword to search',
    normal: 'Normal',
    warning: 'Warning',
    offline: 'Offline',
    keyword: 'Keyword',
    warnStatus: 'Warning Status',
    more: 'More',
    statusDetail: 'Status Detail',
    runStatus: 'Run Status',
    cmdList: 'Command List',
    settingList: 'Setting Records'
  },
  passwordReset: {
    title: 'Change Initial Password',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    oldPasswordPlaceholder: 'Please enter old password',
    newPasswordPlaceholder: 'Please enter new password',
    confirmPasswordPlaceholder: 'Please confirm new password',
    submitBtn: 'Confirm Change',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters',
    passwordSuccess: 'Password changed successfully',
    passwordFail: 'Failed to change password',
    pleaseInputOld: 'Please enter old password',
    pleaseInputNew: 'Please enter new password',
    pleaseConfirm: 'Please confirm new password'
  },
  deviceDetail: {
    title: 'Device Detail',
    deviceVersion: 'Device Version',
    deviceModel: 'Controller Model',
    warnStatus: 'Warning Status',
    statusDetailTitle: 'Device Status Detail',
    controllerVoltage: 'Controller Voltage(V)',
    controllerCurrent: 'Controller Current(A)',
    controllerTemp: 'Controller Temp(℃)',
    motorTemp: 'Motor Temp(℃)',
    workStatus: 'Work Status',
    softOverCurrent: 'Soft Over Current(A)',
    softOverCurrentDuration: 'Soft Over Current Duration(s)',
    motorOverTemp: 'Motor Over Temp Protection(℃)',
    motorControlOverTemp: 'Controller Over Temp Protection(℃)',
    updateTime: 'Update Time',
    runStatusTitle: 'Device Run Status',
    timeRange: 'Time Range',
    startTime: 'Start Time',
    endTime: 'End Time',
    dataList: 'Data List',
    trendChart: 'Trend Chart',
    time: 'Time',
    cmdListTitle: 'Device Command List',
    softOverCurrentRestoreTime: 'Over Current Restore Time(s)',
    motorOverTempProtect: 'Motor Over Temp Protection(℃)',
    motorOverTempRestoreTime: 'Motor Over Temp Restore(s)',
    motorControlOverTempProtect: 'Controller Over Temp Protection(℃)',
    motorControlOverTempRestoreTime: 'Controller Over Temp Restore(s)',
    currentMaxProtect: 'Max Current Protection(A)',
    softBootInitDutyCycle: 'Soft Boot Initial Duty Cycle(%)',
    softBootTime: 'Soft Boot Time(ms)',
    motorControlTempFixedValue: 'Controller Fixed Temp(℃)',
    motorTempFixedValue: 'Motor Fixed Temp(℃)',
    tempSensorType: 'Temp Sensor Type',
    remoteControlPairingMode: 'Remote Control Pairing Mode',
    settingListTitle: 'Setting Records'
  },
  layout: {
    switchToDark: 'Switch to dark mode',
    switchToLight: 'Switch to light mode',
    theme: 'Theme',
    themeSystem: 'Follow System',
    themeDark: 'Dark Mode',
    themeLight: 'Light Mode'
  },
  statusText: {
    stopped: 'Stopped',
    forward: 'Forward',
    reverse: 'Reverse',
    unknown: 'Unknown',
    normal: 'Normal',
    softOverCurrent: 'Soft Over Current',
    hardOverCurrent: 'Hard Over Current',
    motorOverTemp: 'Motor Over Temp',
    motorControlOverTemp: 'Controller Over Temp',
    locked: 'Locked'
  },
  version: {
    type: 'Type',
    versionCode: 'Version Code',
    versionCodePlaceholder: 'Please enter version code',
    versionCodeRequired: 'Please enter version code',
    content: 'Update Content',
    contentPlaceholder: 'Please enter update content',
    fileUrl: 'File URL',
    fileUpload: 'File Upload',
    uploadByFile: 'Local Upload',
    uploadByUrl: 'URL Upload',
    urlPlaceholder: 'Enter URL, click upload to save as new URL (optional)',
    urlRequired: 'Please enter file URL',
    selectFile: 'Select File',
    upload: 'Upload',
    uploadSuccess: 'File uploaded successfully',
    uploadFailed: 'File upload failed',
    fileUploaded: 'File uploaded',
    status: 'Status',
    valid: 'Valid',
    invalid: 'Invalid',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    firmware: {
      title: 'Firmware Management',
      add: 'Add Firmware Version',
      edit: 'Edit Firmware Version',
      deviceModel: 'Device Model',
      deviceModelPlaceholder: 'Please enter device model',
      deviceModelRequired: 'Please enter device model'
    },
    app: {
      title: 'App Version Management',
      add: 'Add App Version',
      edit: 'Edit App Version'
    }
  }
}
